export default __webpack_public_path__ + "static/media/downarrow.ead81e3b.svg";